import { TracksLastDetectionsMapping } from "@/components/tracks-last-detections-mapping";
import { VideoPlayerContainer } from "@/components/video-player-container";
import { PlaybackControls } from "@/playback-controls/playback-controls";
import { convertHeightToPercent } from "@/shared";
import { ViewSettings } from "@/view-settings";
import { VirtualStore } from "@/virtual-store";
import { Canvas2D } from "@/virtual-store/canvas-2D";
import { BinInfoPopup } from "@/virtual-store/planogram/bin-info-popup";
import { selectedBin$ } from "@/virtual-store/state";
import { Separator, Flex } from "@radix-ui/themes";
import { PanelGroup, Panel, PanelResizeHandle } from "react-resizable-panels";
import { TopBar } from "../index/components/top-bar";
import ChromeUsageReminder from "@/shared/ui/chrome-usage-reminder";
import { isChrome } from "react-device-detect";
import "./index.css";
import { TracksCountInfo } from "@/playback-controls/basic-controls";

export function View3D() {
  return (
    <div className="w-screen h-screen insights">
      {!isChrome && <ChromeUsageReminder />}
      <PanelGroup direction="vertical">
        <TopBar />
        <Separator size="4" />
        <header>
          <Flex justify="end" px="4" py="2">
            <ViewSettings />
          </Flex>
        </header>
        <Panel id="some-2" maxSize={100}>
          <PanelGroup direction="horizontal" autoSaveId="view">
            <Panel id="interactive-view" className="relative" order={2}>
              <BinInfoPopup selected$={selectedBin$} />
              <Canvas2D />
              <VirtualStore />
              <TracksLastDetectionsMapping />
              <VideoPlayerContainer />
              <TracksCountInfo />
            </Panel>
          </PanelGroup>
        </Panel>

        <PanelResizeHandle className="h-2 bg-[var(--gray-a7)] active:bg-[var(--gray-a10)] hover:bg-[var(--gray-a9)] hover:transition-1" />
        <Panel
          id="playback-controls"
          defaultSize={convertHeightToPercent(250)}
          collapsible
        >
          <PlaybackControls />
        </Panel>
      </PanelGroup>
    </div>
  );
}
